export const STATUS_LABEL = {
  green: "On Target",
  amber: "At Risk",
  red: "Below Threshold",
  missing: "Missing",
  pending: "Pending",
};

export const STATUS_HEX = {
  green: "#10B981",
  amber: "#F59E0B",
  red: "#EF4444",
  missing: "#64748B",
  pending: "#334155",
};

export const fmtNum = (n) => (n == null ? "—" : Number(n).toLocaleString("en-IN"));
export const fmtPct = (n) => (n == null ? "—" : `${Number(n).toFixed(1)}%`);

export const todayISO = () => {
  const d = new Date();
  const off = d.getTimezoneOffset();
  return new Date(d.getTime() - off * 60000).toISOString().slice(0, 10);
};

export const ROLE_LABEL = { master_admin: "Master Admin", admin: "Admin", mis: "MIS Executive", management: "Management" };
